import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getTimelineEvents, type TimelineEventsResponse } from '../api/timelineEvents';

export const useTimelineEvents = (bookId?: number, options: { enabled?: boolean; isSpoil?: boolean } = {}) => {
  const isSpoil = options.isSpoil ?? false;
  return useQuery<TimelineEventsResponse, Error>({
    queryKey: ['timeline-events', bookId, isSpoil],
    queryFn: () => getTimelineEvents(bookId as number, isSpoil),
    enabled: !!bookId && options.enabled !== false,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
